import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Player } from "@lottiefiles/react-lottie-player";
import { useAuth } from "../context/AuthContext";
import toast from "react-hot-toast";
import logoImg from "../assets/logo.png";
import "./Auth.css";

const Login = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome back!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page auth-page-split">
      <div className="auth-split-left">
        <div className="auth-lottie-wrap">
          <Player
            src="https://assets10.lottiefiles.com/packages/lf20_qp1q7mct.json"
            className="auth-lottie"
            autoplay
            loop
          />
        </div>
        <div className="auth-left-content">
          <h1 className="auth-left-title">IEO/SCS/ICD Task Management</h1>
          <p className="auth-left-tagline">
            Manage tasks, track progress, and get things done.
          </p>
        </div>
      </div>
      <div className="auth-split-right">
        <div className="auth-card auth-card-split">
          <div className="auth-logo-wrap">
            <img src={logoImg} alt="Logo" className="auth-logo" />
          </div>
          <h2 className="auth-title">Welcome back</h2>
          <p className="auth-subtitle">Sign in to your account</p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                className="form-control"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@example.com"
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input
                className="form-control"
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="••••••••"
                required
              />
            </div>
            <div className="auth-forgot-row">
              <Link to="/forgot-password">Forgot password?</Link>
            </div>
            <button
              className="btn btn-primary auth-btn"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <span
                  className="spinner"
                  style={{ width: 18, height: 18, borderWidth: 2 }}
                />
              ) : (
                "Sign In"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
